export var HOME_PAGE_RELATIVE_URL = '/';
export var CANADA_COUNTRY_CODE = 'CA';
export var FRANCE_COUNTRY_CODE = 'FR';
export var US_CURRENCY_CODE = 'USD';
export var QUEBEC_REGION = 'Quebec';
export var USE_NEXT_INTERACTION_ERROR_LOCATION = 'useNextInteraction';
export var CLICKSTREAM_VIEW = 'clickstream_view';
export var CLICKSTREAM_INTERACTION = 'clickstream_interaction';

// This Map is used to map the country code to the currency code for all the currencies that wt product supports
// Only ctfm supports multiple currencies (USD, AUD,GBP )
export var mapCountryCodeToCurrencyCode = {
  US: 'USD',
  // United States
  GB: 'GBP',
  // United Kingdom
  AU: 'AUD' // Australia
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/constants.js
// module id = 456
// module chunks = 11